// extracted by mini-css-extract-plugin
export default {"fullWidth":"Yn-z","image":"Zn-z","lazyLoadPicture":"_n-z","lazyLoadSpinner":"ao-z","lazyLoadSpin":"bo-z","lazyLoadImage":"co-z","hasStyledAspectRatio":"do-z"};